const messages = {
  pt: {
    translations: {
      app: { title: "Numera Builder" },
      errors: { generic: "Ocorreu um erro. Tente novamente." },
      login: {
        title: "Entrar",
        email: "E-mail",
        password: "Senha",
        submit: "Entrar",
        invalid: "Credenciais inválidas",
      },
      menu: {
        groups: {
          telefonia: "Telefonia",
          builder: "Construtor",
          integrations: "Integrações",
        },
        dashboard: "Painel",
        assistant: "Assistente",
        numbers: "Números",
        cdrs: "Chamadas",
        applications: "Automações",
        templates: "Templates",
        events: "Eventos",
        alerts: "Alertas",
        connectors: "Conectores",
        collectors: "Coletores de dados",
        jobs: "Scripts",
        vault: "Segredos",
        datasets: "Tabelas",
        extensions: "Ramais",
        storage: "Armazenamento",
        secrets: "Secrets",
        webhooks: "Webhooks",
        usage: "Uso & Saldo",
        developers: "Desenvolvedores",
        agents: "Agentes de IA",
        schedules: "Agendamentos",
        data: "Dados",
        users: "Usuários",
        logout: "Sair",
      },
      events: {
        title: "Eventos",
        clear: "Limpar",
        confirmClear: "Apagar todos os eventos?",
        empty: "Nenhum evento ainda.",
        loadMore: "Carregar mais",
        selectHint: "Selecione um evento para ver os detalhes.",
        today: "Hoje",
        yesterday: "Ontem",
        app: "Automação",
        type: "Tipo",
      },
      apps: {
        title: "Automações",
        new: "Nova automação",
        search: "Buscar automações",
        empty: "Nenhuma automação. Clique em \"Nova automação\" para começar.",
        name: "Nome",
        trigger: "Gatilho",
        updatedAt: "Atualizado em",
        lastRunAt: "Última execução",
        confirmDelete: "Excluir esta automação?",
        saved: "Automação salva.",
        namePlaceholder: "Nome da automação",
        previewJson: "Pré-visualizar JSON",
        copy: "Copiar",
        copied: "JSON copiado.",
        copiedShort: "Copiado",
        close: "Fechar",
        status: "Status",
        publish: "Publicar",
        published: "Publicada v{{v}} e implantada.",
        publishedShort: "Publicada",
        unpublished: "Não publicada",
        unpublishedShort: "alterações não publicadas",
        draftStatus: "Rascunho",
        history: "Histórico",
        version: "Versão",
        deploy: "Deploy",
        when: "Quando",
        notes: "Notas",
        live: "No ar",
        archived: "Arquivada",
        restore: "Restaurar",
        restored: "Versão v{{v}} restaurada no rascunho.",
        noVersions: "Ainda não há versões publicadas.",
        saveFirst: "Salve a automação primeiro.",
        addStep: "Adicionar passo",
      },
      vars: {
        title: "Selecionar variável",
        search: "Buscar variáveis no escopo...",
        select: "Selecionar",
        insert: "Inserir variável",
        empty: "Gere um evento de teste no gatilho para ver as variáveis.",
        noMatch: "Nenhuma variável encontrada.",
      },
      triggers: {
        title: "Gatilho",
        choose: "Escolher gatilho",
        add: "Adicionar gatilho",
        change: "Trocar gatilho",
        empty: "Nenhum gatilho definido. Escolha como esta automação é disparada.",
        webhookUrl: "URL do webhook",
        webhookSaveHint: "Salve a automação para gerar a URL.",
        testEvent: "Evento de teste",
        exampleBody: "Corpo de exemplo (JSON)",
        generateTest: "Gerar evento de teste",
        invalidJson: "JSON inválido no corpo de exemplo.",
        tested: "Evento de teste gerado.",
        exports: "Exports (referenciáveis nos nós abaixo)",
        tabConfig: "Configuração",
        tabEvents: "Eventos",
        tabResults: "Resultados",
        noEvents: "Nenhum evento ainda. Use \"Testar evento\" ou chame a URL do webhook.",
        selectEventHint: "Selecione um evento na seção Eventos para ver os dados.",
        schemaHint: "Exemplo dos campos que este gatilho recebe — use estes caminhos como variáveis (ainda não houve evento real).",
        refresh: "Atualizar",
        method: "Método",
        sendTest: "Enviar requisição",
        testSent: "Requisição enviada.",
        testHint: "Dispara uma requisição real no webhook desta automação; o evento aparece na aba Eventos.",
        inbound_call: {
          title: "Ao receber chamada",
          desc: "Dispara quando uma chamada chega num número vinculado a esta automação.",
        },
        webhook: {
          title: "Webhook",
          desc: "Dispara quando um sistema externo chama uma URL (HTTP). Útil para originar chamadas.",
        },
        scheduled: {
          title: "Agendado",
          desc: "Dispara em horários definidos (expressão cron).",
        },
      },
      numbers: {
        title: "Números",
        search: "Buscar por número ou cidade",
        empty: "Nenhum número encontrado.",
        number: "Número",
        type: "Tipo",
        city: "Cidade",
        inbound: "Automação (entrada)",
        outbound: "Automação (saída)",
        types: { fixo: "Fixo", movel: "Móvel" },
        link: "Vincular automações",
        none: "Nenhuma",
        linkHint: "Entrada: o fluxo ou agente que atende quando alguém liga para este número. Para ligar a partir dele, escolha o número no nó Iniciar chamada.",
      },
      projects: {
        title: "Projetos",
        new: "Novo projeto",
        search: "Buscar projetos",
        empty: "Nenhum projeto encontrado.",
        name: "Nome",
        status: "Status",
        owner: "Responsável",
        updatedAt: "Atualizado em",
        confirmDelete: "Excluir este projeto?",
        deleted: "Projeto excluído.",
        saved: "Projeto salvo.",
      },
      status: {
        draft: "Rascunho",
        active: "Ativo",
        paused: "Pausado",
        archived: "Arquivado",
      },
      config: {
        back: "Voltar",
        save: "Salvar",
        tabs: { general: "Geral", advanced: "Avançado" },
        fields: {
          name: "Nome",
          description: "Descrição",
          status: "Status",
        },
        validation: { nameRequired: "Informe um nome" },
      },
    },
  },
};

export { messages };
